import { Component, OnInit } from '@angular/core';
import { NewsService } from '../../providers/noticias.service';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.scss']
})
export class NoticiasComponent implements OnInit {

  list = [];
  pageCurrent = 1;
  totalPages: number;

  constructor(private newsService: NewsService) { }

  loadPackages() {

    const limitToPage = 9;

    this.newsService.getNews(this.pageCurrent, limitToPage)
    .subscribe(
      result => {
        this.list = result.dados;
        this.totalPages = Math.floor(result.total / limitToPage);
      },
      error => {
        console.log('Ops' + error);
      }
    );

  }

  updatePagination(event) {
    this.pageCurrent = event;
    this.loadPackages();
  }

  ngOnInit() {
    this.loadPackages();
  }

}
